import { render, staticRenderFns } from "./talent.vue?vue&type=template&id=5db1de37"
import script from "./talent.vue?vue&type=script&lang=js"
export * from "./talent.vue?vue&type=script&lang=js"
import style0 from "./talent.vue?vue&type=style&index=0&id=5db1de37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports